module.exports = __webpack_public_path__ + "fea03c96301addc2e0a4a02c87f8950f.svg";